module.exports = __webpack_public_path__ + "static/media/search-icon.625322a5.png";